/********************************************************************
 * ADOBE CONFIDENTIAL
 * __________________
 *
 *  Copyright 2024 Adobe
 *  All Rights Reserved.
 *
 * NOTICE:  All information contained herein is, and remains
 * the property of Adobe and its suppliers, if any. The intellectual
 * and technical concepts contained herein are proprietary to Adobe
 * and its suppliers and are protected by all applicable intellectual
 * property laws, including trade secret and copyright laws.
 * Dissemination of this information or reproduction of this material
 * is strictly forbidden unless prior written permission is obtained
 * from Adobe.
 *******************************************************************/

import { handleNetworkError } from '@/account/lib/network-error';
import { fetchGraphQl } from '@/account/api/fetch-graphql';
import { handleFetchError } from '@/account/lib/fetch-error';
import { GET_CUSTOMER } from './graphql/getCustomer.graphql';
import { transformCustomer } from '@/account/data/transforms';
import { CustomerDataModelShort } from '@/account/data/models/customer';
import { getCustomerShortResponse } from '@/account/types';

export const getCustomer = async (): Promise<CustomerDataModelShort> => {
  return await fetchGraphQl(GET_CUSTOMER, {
    method: 'GET',
    cache: 'no-cache',
  })
    .then((response: getCustomerShortResponse) => {
      if (response.errors?.length) return handleFetchError(response.errors);

      return transformCustomer(response);
    })
    .catch(handleNetworkError);
};
